import React from 'react';
import {classNames} from "@/utils/general";

function DefaultIcon(props: { status: string, additionalClasses?: string }) {
  const status = props.status;
  return (
    <div className="flex items-center h-full">
      <div
        className={classNames(status === "paid" ? "bg-green-200 text-green-900" : "bg-yellow-100 text-yellow-900", "px-2 py-1 my-auto text-xs rounded items-center", props.additionalClasses)}>
        {
          status === "paid" ?
            <p>Paid</p>
            :
            <p>Pending</p>
        }
      </div>
    </div>
  );
}

export default DefaultIcon;
